import { render, staticRenderFns } from "./OnlinePayment.vue?vue&type=template&id=265f3dac&scoped=true"
import script from "./OnlinePayment.vue?vue&type=script&lang=js"
export * from "./OnlinePayment.vue?vue&type=script&lang=js"
import style0 from "./OnlinePayment.vue?vue&type=style&index=0&id=265f3dac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "265f3dac",
  null
  
)

export default component.exports